import { render } from "./ProductPriceCheckComponent.vue?vue&type=template&id=82e11ba0&scoped=true&ts=true"
import script from "./ProductPriceCheckComponent.vue?vue&type=script&lang=ts"
export * from "./ProductPriceCheckComponent.vue?vue&type=script&lang=ts"

import "./ProductPriceCheckComponent.vue?vue&type=style&index=0&id=82e11ba0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-82e11ba0"]])

export default __exports__